import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e1a25db"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"message-booking-history\" data-v-3e1a25db><div class=\"grid m-0\" data-v-3e1a25db><div class=\"col-4 th\" data-v-3e1a25db>予約日</div><div class=\"col-4 th\" data-v-3e1a25db>予約枠</div><div class=\"col-4 th\" data-v-3e1a25db>予約ステータス</div></div></div>", 1)
const _hoisted_2 = { class: "customer-list-booking overflow-scroll h-full" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "col-3 td" }
const _hoisted_5 = { class: "col-6 td" }
const _hoisted_6 = { class: "col-3 td" }

import { ref, onMounted, watch } from "vue";
import { get, useDateFormat } from "@vueuse/core";
import type { IBooking } from "@/clinic/typings";
import { DATE_FORMAT } from "@/clinic/typings/constants/booking";
import TimeUtils from "@/clinic/utils/time-utils";
import { BookingStatusEnum } from "@/clinic/typings/enums/booking";


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingHistory',
  props: {
    bookings: null
  },
  emits: ["bookingClick"],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  bookings: IBooking[];
};





const handleBookingClick = booking => {
  emits("bookingClick", booking);
};

watch(props, newValue => {
  bookingsVal.value = newValue.bookings;
});

const bookingsVal = ref<IBooking[]>([]);
const initAttributes = () => {
  if (!bookingsVal.value.length) {
    bookingsVal.value = props.bookings;
  }
};
const rangeTime = (start: Date, end: Date) => {
  if (!start || !end) return "";
  return TimeUtils.formatRangeDateTime(start, end);
};
onMounted(() => {
  initAttributes();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bookingsVal.value, (booking, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "grid m-0 cursor-pointer",
          key: index,
          onClick: () => handleBookingClick(booking)
        }, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(get)(_unref(useDateFormat)(booking.start_time, _unref(DATE_FORMAT)))), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(get)(rangeTime(booking.start_time, booking.end_time))), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(BookingStatusEnum)[booking.status]), 1)
        ], 8, _hoisted_3))
      }), 128))
    ])
  ], 64))
}
}

})